import Api from '@/api/api'

export default {
    getActors() {
        return Api.get(`/api/settings/GetAllActorFieldForSuperAdmin`)
    },
    getInitialData() {
        return Api.get(`/api/InitialData/GetSuperAdminInitialData`);
    },
    addActor(data) {
        return Api.post(`/api/settings/AddActorField`, data);
    },
    updateActor(editId, data) {
        return Api.put(`/api/settings/UpdateActorField?ID=${editId}`, data);
    },
    deleteActor(actorId) {
        return Api.delete(`/api/settings/DeleteActorField?Id=${actorId}`);
    },
 }